<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeIntegrations/">Integrations</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/storeConnections/">Create Channel</a></li>
      <li class="breadcrumb-item active" aria-current="page">Zoho Commerce</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <div class="row">
          <div class="col-md-4">

            <div class="form-group">
              <label class="control-label" for="channelName">Channel Name</label>
              <input type="text" id="channelName" class="form-control"
                     [ngClass]="{'is-invalid':connectionNameError}" [(ngModel)]="connectionName" [ngModelOptions]="{standalone: true}"
                     placeholder="Channel Name" required>
              <div id="connectionNameError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!connectionNameError"
                   style="position: absolute;">{{connectionNameError}}
              </div>
            </div>

            <div class="form-group">
              <label class="control-label" for="version">Client Id</label>
              <input type="text" id="version" class="form-control"
                     [ngClass]="{'is-invalid':clientIdError}" [(ngModel)]="clientId" [ngModelOptions]="{standalone: true}"
                     placeholder="Client Id" required>
              <div id="clientIdError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!clientIdError"
                   style="position: absolute;">{{clientIdError}}
              </div>
            </div>
          </div>
            <div class="col-md-4">
            <div class="form-group">
              <label class="control-label" for="clientSecret">Client Secret</label>
              <input type="text" id="clientSecret" class="form-control"
                     [ngClass]="{'is-invalid':clientSecretError}" [(ngModel)]="clientSecret" [ngModelOptions]="{standalone: true}"
                     placeholder="clientSecret" required>
              <div id="clientSecretError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!clientSecretError"
                   style="position: absolute;">{{clientSecretError}}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label" for="storeOrganizationId">Store Organization Id</label>
              <input type="text" id="storeOrganizationId" class="form-control"
                      [(ngModel)]="storeOrganizationId" [ngModelOptions]="{standalone: true}"
                     placeholder="StoreOrganizationId" required>
          <!--    <div id="storeOrganizationIdError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!storeOrganizationIdError"
                   style="position: absolute;">{{storeOrganizationIdError}}
              </div>-->
            </div>
           </div>
          <div class="col-md-3 align-self-end">
            <button class="instr-box btn btn-cancel btn-block" (click)="showInstructions()">
              <span>Zoho Commerce Market Place Instructions </span>
              <svg
                xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle" d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z" transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
            </button>
            <button class="btn btn-orange btn-block" (click)="submitZoho()">Test Connection & Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4" id="instructions" [hidden]="instructions == 'N'">
    <div class="col">
      <div class="inner-box pb-0 pt-4 h-auto">
        <div class="row">
          <div class="col-12">
            <div class="row no-gutters">
              <label>
                <b>Instructions :</b>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <ul>
                <li>
                  Login to Zoho API console with your Zoho store credentials.
                </li>
                <li>
                  Then go to client type, under which you need to choose Sever-Based Application.
                </li>
                <li>
                  Register a create new client account and fill in the required information. You will need an Authorized Redirect URI, along with your homepage URL to be entered in order to complete the process.
                </li>
                <li>
                  Once created, this will automatically generate a client id and client secret.
                </li>
                <li>
                  The client id and client secret are then required to be entered into the Shift application to complete the Zoho Commerce channel integration process.
                </li>
                <li>
                  There is also a Store ID that needs to be entered into the Shift system, which is optional, in situations where you have multiple stores on Zoho.
                </li>
                <li>
                  To find the Store ID, login to your zoho account, go to my store… (need to be filled )
                </li>
                <li>
                  Note: If you have any questions regarding the instructions, feel free to reach out to us. We are always happy to help.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
